import React from "react";
import StaticPage from "./StaticPage";
export default function Blog() {
  return (
    <StaticPage title="The SchoolLane Blog" subtitle="Best practices, product updates and stories from schools using SchoolLane.">
      <div className="not-prose grid md:grid-cols-2 gap-6 mt-2">
        {[
          "How Delhi Public School Bengaluru cut procurement time by 60%",
          "The 11-step procurement workflow, explained simply",
          "Parents want convenience: what our data says",
        ].map((t) => (
          <div key={t} className="sl-card p-6">
            <div className="text-xs text-slate-500">Product · 4 min read</div>
            <h3 className="mt-2 font-heading font-semibold text-lg text-slate-900">{t}</h3>
            <p className="mt-2 text-sm text-slate-600">Coming soon.</p>
          </div>
        ))}
      </div>
    </StaticPage>
  );
}
